// extracted by css-extract-rspack-plugin
export default {"appList":"fhsXD"};